import React, {Fragment, useEffect, useRef, useState} from "react";

import {Badge, Card, CardBody, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Button, Spinner} from "reactstrap";

import {useDispatch, useSelector} from "react-redux";
import { Zap } from "react-feather";
import { toast } from "react-toastify";
import { generateAiProductSeo } from "../../../store/prodcutSlice";
import { MdAutoAwesome } from "react-icons/md";



const ProductSeo = (props) => {
    const {setValue, trigger, getValues, errors, register} = props;
    const metaTitleLength=getValues('meta_title')?getValues('meta_title').length:0;
    const metaDescriptionLength=getValues('meta_description')?getValues('meta_description').length:0

    const dispatch = useDispatch();
    const [aiSeoLoading, setAiSeoLoading] = useState(false);


    const handleAiGenerateSeo = async () => {
        const productId = getValues('id');
        if (!productId) {
            toast.error("Product ID missing.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (!getValues('description')) {
            toast.error("Please generate/fill Product Description first.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (!getValues('summary')) {
            toast.error("Please generate/fill Product Summary first.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setAiSeoLoading(true);
        try {
            const res = await dispatch(generateAiProductSeo({ productId })).unwrap();

            const metaTitle = res?.data?.meta_title ?? res?.data?.seo_title ?? null;
            const metaDesc = res?.data?.meta_description ?? res?.data?.seo_description ?? null;

            if (!metaTitle || !metaDesc) {
                toast.error("AI returned empty SEO data.", { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            setValue('meta_title', metaTitle);
            setValue('meta_description', metaDesc);

            trigger('meta_title');
            trigger('meta_description');

            toast.success("SEO title and description generated.", { position: toast.POSITION.TOP_RIGHT });
        } catch (e) {
            const msg = e?.response?.data?.message || e?.message || "Failed to generate SEO meta.";
            toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
        } finally {
            setAiSeoLoading(false);
        }
    };

    return (
        <Fragment>
            <Card>
                <CardBody>
                    <div className="ribbon ribbon-clip ribbon-info ribbon-left mb-5">Seo Related</div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                        <Button
                            type="button"
                            color="primary"
                            size="sm"
                            disabled={aiSeoLoading}
                            onClick={handleAiGenerateSeo}
                            style={{ display: "flex", alignItems: "center", gap: 6 }}
                        >
                            {aiSeoLoading ? <Spinner size="sm" /> : <MdAutoAwesome style={{ fontSize: 16 }} />}
                            Generate SEO With AI
                        </Button>
                    </div>
                    <div className="form-row mb-3">
                        <Col md="12">
                            <FormGroup>
                                <Label className="col-form-label">Meta Title <span className="text-limit">(Character Limit: {65}, Remaining: {65-metaTitleLength})</span></Label>
                                <input name="meta_title" type="text" {...register('meta_title')}
                                    maxLength={65}
                                       onKeyUp={()=>{
                                           trigger('meta_title');
                                       }}
                                       className={`form-control ${errors.meta_title ? 'is-invalid' : ''}`}/>
                                <div className="invalid-feedback">{errors.meta_title?.message}</div>
                            </FormGroup>
                        </Col>
                    </div>
                    <div className="form-row mb-3">
                        <Col md="12">
                            <FormGroup>
                                <Label className="col-form-label">Meta Description <span className="text-limit">(Character Limit: {160}, Remaining: {160-metaDescriptionLength})</span></Label>
                                <textarea {...register('meta_description')} className={`form-control`} rows={3}    maxLength={160}    onKeyUp={()=>{
                                    trigger('meta_description');
                                }}></textarea>
                            </FormGroup>
                        </Col>
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
}

function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps.getValues) == JSON.stringify(nextProps.getValues);
    /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
}

export default ProductSeo;